export const AUTH_CALLBACK_DONE_KEY = 'terra-auth-callback-done';
